import {getInitials, useComponentsTheme} from 'platform/components';
import {getSize, ThemeColorPath} from 'platform/foundation';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {resolveCalendarColor} from '../utils/resolveCalendarColor';

interface UserColorAvatarProps extends TestIdProps {
  name: string;
  color: ThemeColorPath | string | Nullish;
}

const AVATAR_SIZE = 7; // matches platform Avatar size="small"

/**
 * Local avatar chip for calendar users. Platform Avatar accepts only theme color paths,
 * while calendar user colors are raw #RRGGBB values — render the colored circle here
 * instead of widening the platform Avatar API.
 */
export function UserColorAvatar(props: UserColorAvatarProps) {
  const theme = useComponentsTheme();

  return (
    <div
      data-testid={suffixTestId('avatar', props)}
      className="flex items-center justify-center rounded-full leading-none font-medium whitespace-nowrap text-[var(--color-white)]"
      style={{
        width: getSize(AVATAR_SIZE),
        height: getSize(AVATAR_SIZE),
        backgroundColor: resolveCalendarColor(props.color, theme),
        fontFamily: theme.fonts.body,
        fontSize: theme.fontSizes.text.xSmall,
      }}
    >
      {getInitials(props.name)}
    </div>
  );
}
